import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SharedModule } from '@myproject/shared/shared.module';
import { RedesignComponent } from './redesign.component';
import { OperationalInsightsComponent } from './operational-insights/operational-insights.component';
import { ProductCodeDistributionComponent } from './product-code-distribution/product-code-distribution.component';
import { ProtocolReportComponent } from './protocol-report/protocol-report.component';
import { SimUsageReportComponent } from './sim-usage-report/sim-usage-report.component';

@NgModule({
  declarations: [
    RedesignComponent,
    OperationalInsightsComponent,
    ProductCodeDistributionComponent,
    ProtocolReportComponent,
    SimUsageReportComponent,
  ],
  imports: [CommonModule, FormsModule, SharedModule, NgxDatatableModule],
  exports: [RedesignComponent],
})
export class RedesignModule {}
